import React, { useState } from "react";
import * as httpClient from "../../util/httpClient";
import { getServiceKey, useBureauPermission } from "../../util/credit";
import * as CreditActions from "../../store/credit/actions";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { ezsServiceIds } from "../../config/UserServicesList";
import { useAreServicesActive } from "../../util/CommonServices";

const CreditExpired = (props: any) => {
    const { t: tLang } = useTranslation();
    const dispatch = useDispatch();
    const bureauPermission = useBureauPermission();
    const requestCreditData = () => dispatch(CreditActions.actionCreators.requestCreditData(true, bureauPermission));

    const [isLoading, setIsLoading] = useState(false);

    const servicesNotAllowedForRefrsh = [ezsServiceIds.tuQuarterlyCreditScore];
    const notAllowedServiceToRefresh = useAreServicesActive(servicesNotAllowedForRefrsh);

    const handleSubmit = (e: any) => {
        setIsLoading(true);
        e.preventDefault();
        const requestBody = {
            "bureau-opt": getServiceKey(bureauPermission),
        };
        httpClient
            .sendRequest("POST", `api/credit-monitoring/refreshCreditData`, requestBody)
            .then((data) => {
                requestCreditData();
                setIsLoading(false);
            })
            .catch(function (error) {
                requestCreditData();
                setIsLoading(false);
            });
    };

    return (
        <div className={`${isLoading && "loading"}`}>
            <h3 className="content-title">{tLang("credit.creditScore.creditScoreWidget.label.reportExpired")}</h3>
            {!notAllowedServiceToRefresh && (
                <div className="row between-xs">
                    <div className="col-xs-9 col-gutter-vertical flex-grow-null">
                        <p>{tLang("credit.creditScore.creditScoreWidget.label.reportExpiredMessage")}</p>
                    </div>

                    <div className="col-xs-3 col-gutter-vertical flex-grow-null">
                        <button
                            type="button"
                            className="btn-default btn-primary"
                            onClick={(e: any) => {
                                handleSubmit(e);
                                window.addToDataLayer({ event: "Refresh Score" });
                            }}
                        >
                            <span className="btn-text">{tLang("credit.creditScore.creditScoreWidget.refreshScorebtn")}</span>
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CreditExpired;
